import React from 'react';

export const Refund = () => {
  return (
    <div className="min-h-screen pt-20 pb-12">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Cancellation & Refund Policy</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-sm text-gray-500 mb-8">Last updated: November 11, 2025</p>
          
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed mb-6">
              SANGHVI INFONET PRIVATE LIMITED believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:
            </p>

            <div className="space-y-6">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">Cancellation Timeframe</h3>
                <p className="text-gray-700 leading-relaxed">
                  Cancellations will be considered only if the request is made within 1-2 days of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">Non-Cancellable Items</h3>
                <p className="text-gray-700 leading-relaxed">
                  SANGHVI INFONET PRIVATE LIMITED does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">Damaged or Defective Items</h3>
                <p className="text-gray-700 leading-relaxed">
                  In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within 1-2 days of receipt of the products.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">Product Quality Issues</h3>
                <p className="text-gray-700 leading-relaxed">
                  In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 1-2 days of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">Warranty Claims</h3>
                <p className="text-gray-700 leading-relaxed">
                  In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.
                </p>
              </div>

              <div className="bg-red-50 p-6 rounded-lg border-l-4 border-red-600">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">Refund Processing Time</h3>
                <p className="text-gray-700 leading-relaxed">
                  In case of any Refunds approved by the SANGHVI INFONET PRIVATE LIMITED, it'll take 3-5 days for the refund to be processed to the end customer.
                </p>
              </div>
            </div>
          </section>

          <section className="mt-12 bg-blue-50 p-6 rounded-lg">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">How to Request a Cancellation or Refund</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              To request a cancellation or refund, please contact our customer service team:
            </p>
            <div className="bg-white p-4 rounded-lg">
              <p className="text-gray-700 mb-2"><strong>Email:</strong> info@i5world.com</p>
              <p className="text-gray-700 mb-2"><strong>Address:</strong> 907 Pinnacle Business Park, Corporate Road, Prahlad Nagar, Ahmedabad, Gujarat - 380015</p>
            </div>
            <p className="text-gray-700 leading-relaxed mt-4">
              Please include your order details and reason for cancellation/refund in your request.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
